import {Component, OnInit} from '@angular/core';
import {UserService} from '../../../core/services/user.service';
import {Router} from '@angular/router';
import {HttpService} from '../../../core';


@Component({
  selector: 'app-new-project',
  templateUrl: './new-project.component.html',
  styleUrls: ['./new-project.component.scss']
})

export class NewProjectComponent implements OnInit{

  highestRole: any;

  constructor(
    private userService: UserService,
    private router: Router,
    private httpService: HttpService
  ) {
  }

  ngOnInit(): void {
    this.userService.currentUser.subscribe((user: any) => {
      this.highestRole = user.roles[0];
      if (this.highestRole.weight < 1000) {
        this.router.navigateByUrl('/projects');
      }
    });
  }
}
